var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMouse = function SvgMouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "mouse_svg__svg-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.5,
    width: 12.2,
    height: 18.799,
    rx: 6.1,
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 4.099,
    width: 3.2,
    height: 3.2,
    rx: 1.6,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.898 23.699v-13.8M4.9 21.9 7 24l2.1-2.1"
  })));
};

export { SvgMouse as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cmVjdCB4PSIwLjkwMDE0NiIgeT0iMC40OTk3NTYiIHdpZHRoPSIxMi4xOTk3IiBoZWlnaHQ9IjE4Ljc5OTUiIHJ4PSI2LjA5OTg0IiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPjxyZWN0IHg9IjUuNDAwMTUiIHk9IjQuMDk5MzciIHdpZHRoPSIzLjE5OTkiIGhlaWdodD0iMy4xOTk5IiByeD0iMS41OTk5NSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz48bGluZSB4MT0iNi44OTgxOSIgeTE9IjIzLjY5OSIgeDI9IjYuODk4MTkiIHkyPSI5Ljg5OTMiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+PHBhdGggZD0iTTQuOTAwMTUgMjEuOTAwMUw3LjAwMDEgMjQuMDAwMUw5LjEwMDA1IDIxLjkwMDEiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+PC9zdmc+";